import APIClient from "../client";

const driversAPI = {
  get: () => {
    return APIClient.get("/driver");
  },
  create: (payload) => {
    return APIClient.post("/driver", payload);
  },
  delete: (id) => {
    return APIClient.delete(`/driver/${id}`);
  },
  activate: (id) => {
    return APIClient.patch(`/driver/${id}/activate`);
  },
  deactivate: (id) => {
    return APIClient.patch(`/driver/${id}/deactivate`);
  },
};

export default driversAPI;
